import styled from "styled-components";

export const Div = styled.div`
   height: calc(100vh - 105px);
   display: grid;
   grid-template-rows: 1fr 3fr;
`;
